"use client";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

type Props = {
  data: { name: string; weight: number }[];
};

export default function FeatureBarChart({ data }: Props) {
  if (!data || data.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        No microbial features available for visualization.
      </p>
    );
  }

  return (
    <div className="w-full h-80">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 10, right: 20, left: 40, bottom: 10 }}
        >
          <XAxis type="number" />
          <YAxis type="category" dataKey="name" width={150} />
          <Tooltip />
          <Bar dataKey="weight" fill="#ec4899" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
